import http from '@/api/common'

export default {
  getChannels(options) {
    return http.get(`chat/SendBirdGroupChannels?token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}&includeMembers=1&chatChannelType=${options.channelType}`)
  },
  getChatUsers(options) {
    return http.get(`chat/SendBirdUsers?token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}`)
  },
  getChatUserChannels(options) {
    return http.get(`chat/SendBirdUserChannels?userid=${options.userid}&token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}`)
  },
  removeChannels(data) {
    return http.post('chat/RemoveGroupChannel', data)
  },
  removeUsers(data) {
    return http.post('chat/RemoveUser', data)
  },
  saveMessage(data) {
    return http.post('message/InsertUserMessage', data)
  },
  saveTranslatedMessage(data) {
    return http.post('message/AddMessageTranslated', data)
  },
  getChatHistory(id) {
    return http.get(`Message/ServiceRequestMessages?id=${id}&language=en`)
  },
  saveChatMessages(data) {
    return http.post('chat/SaveChatHistoryWait', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/chat.js